import type { ReactElement } from 'react';
import { Div } from '@fastnorth/kraken/components/layout';
import {
  raceSummarySwatchStripeVariants,
  raceSummarySwatchVariants,
} from './RaceSummaryStatSwatch.styles';

export type RaceSummaryStatSwatchProps = {
  variant: 'onCourse' | 'finished';
};

const RaceSummaryStatSwatch = ({ variant }: RaceSummaryStatSwatchProps): ReactElement => {
  if (variant === 'finished') {
    return (
      <Div
        aria-hidden
        className={raceSummarySwatchVariants({ variant: 'finished' })}
        data-testid="race-summary-swatch-finished"
      />
    );
  }

  return (
    <Div
      aria-hidden
      className={raceSummarySwatchVariants({ variant: 'onCourse' })}
      data-testid="race-summary-swatch-on-course">
      <Div className={raceSummarySwatchStripeVariants()} />
    </Div>
  );
};

export default RaceSummaryStatSwatch;
